import { render, staticRenderFns } from "./RightBox2.vue?vue&type=template&id=a3da365a&scoped=true"
import script from "./RightBox2.vue?vue&type=script&lang=js"
export * from "./RightBox2.vue?vue&type=script&lang=js"
import style0 from "./RightBox2.vue?vue&type=style&index=0&id=a3da365a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3da365a",
  null
  
)

export default component.exports